module.exports = __webpack_public_path__ + "img/井盖边框.2644519a.png";